export default "__VITE_ASSET__Dfovf84M__"